import { c as _c } from "react/compiler-runtime";
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { DocumentRequestKind } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';
const useGuidelines = t0 => {
  const $ = _c(23);
  const {
    docKind,
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.non-id-doc.pages.document-prompt.guidelines"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const shouldOmitBankCreditCardStatement = config.flags.noBankCreditCardStatementForPoA;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp3);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp4);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let poaGuidelines;
  if ($[9] !== shouldOmitBankCreditCardStatement || $[10] !== t || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    poaGuidelines = [t2, t3, t4, t5];
    if (!shouldOmitBankCreditCardStatement) {
      let t6;
      if ($[16] !== t) {
        t6 = t(_temp5);
        $[16] = t;
        $[17] = t6;
      } else {
        t6 = $[17];
      }
      poaGuidelines.push(t6);
    }
    $[9] = shouldOmitBankCreditCardStatement;
    $[10] = t;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = poaGuidelines;
  } else {
    poaGuidelines = $[15];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== poaGuidelines) {
    t9 = {
      [DocumentRequestKind.ProofOfAddress]: poaGuidelines,
      [DocumentRequestKind.ProofOfSsn]: t6,
      [DocumentRequestKind.Identity]: t7,
      [DocumentRequestKind.Custom]: t8
    };
    $[21] = poaGuidelines;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const dockindToGuidelines = t9;
  return dockindToGuidelines[docKind];
};
export default useGuidelines;
function _temp($) {
  return $["gas-water-electricity-bill"];
}
function _temp2($_0) {
  return $_0["vehicle-voter-registration"];
}
function _temp3($_1) {
  return $_1["rental-agreement"];
}
function _temp4($_2) {
  return $_2["phone-internet-bill"];
}
function _temp5($_3) {
  return $_3["bank-credit-card-statement"];
}